<div class="table-toolbar">
  @if (showArchivedFilter) {
    <mat-checkbox color="primary" [(ngModel)]="showArchived" (change)="onArchivedChanged($event)">
      Show Archived
    </mat-checkbox>
  }
  <span class="spacer"></span>
  @if (searchVisible) {
    <input matInput #searchInput id="search-input" class="list-search-input"
           (input)="applyFilter($event)" placeholder="Search by name">
  }
  <button mat-icon-button (click)="toggleSearch()" matTooltip="Search">
    <mat-icon>search</mat-icon>
  </button>
  @if (tableKey) {
    <button mat-icon-button (click)="openTableSettings()" matTooltip="Table Settings">
      <mat-icon>view_column</mat-icon>
    </button>
  }
</div>
<table mat-table [dataSource]="fundDataSource" matSort #fundSort="matSort">
  <ng-container matColumnDef="fundId">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
    <td mat-cell *matCellDef="let element">{{element.id}}</td>
  </ng-container>
  <ng-container matColumnDef="fundName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fund</th>
    <td mat-cell *matCellDef="let element">
      @if (element.isArchived?.value) {
        <mat-icon class="archived-icon">inventory_2</mat-icon>
      }
      {{element.name | traceableFormat}}
    </td>
  </ng-container>
  <ng-container matColumnDef="country">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Country</th>
    <td mat-cell *matCellDef="let element">{{element.country.code | codeFormat: codeTableCountry | async}}</td>
  </ng-container>
  <ng-container matColumnDef="currencyIso">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Currency</th>
    <td mat-cell *matCellDef="let element">{{element.currencyIso.code | codeFormat: codeTableCurrency | async}}</td>
  </ng-container>
  <ng-container matColumnDef="size">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>This Fund Size</th>
    <td mat-cell *matCellDef="let element">{{element.size | traceableFormat}}</td>
  </ng-container>
  <ng-container matColumnDef="mainFundSize">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Main Fund Size</th>
    <td mat-cell *matCellDef="let element">{{element.mainFundSize | traceableFormat}}</td>
  </ng-container>
  <ng-container matColumnDef="vintageYear">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Vintage Year</th>
    <td mat-cell *matCellDef="let element">{{element.vintageYear | traceableFormat}}</td>
  </ng-container>
  <ng-container matColumnDef="endYear">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Fund Ends</th>
    <td mat-cell *matCellDef="let element">{{element.endYear | traceableFormat}}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="fundColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: fundColumns" (click)="emitFundClick(row.id, row.name.text, row.size)">
  </tr>
</table>
<mat-paginator
  #fundPaging
  [pageSizeOptions]="pageSizeOptions"
  [pageSize]="pageSize"
  showFirstLastButtons>
</mat-paginator>
